import { BigNumber, ethers } from "ethers";
import referralAbi from "../../abi/referral.json";
import { showErrorAlert, showPendingAlert } from "../showAlert";
import { ALL_REFERRALS, ALL_REWARD_VESTING } from "../constant/referrals";
import rewardVestingAbi from "../../abi/rewardVesting.json";

export const createReferralCode = async (
  userAddress: string,
  chainId: number,
  provider: any,
  code: string
) => {
  let res;

  const signer = provider.getSigner(userAddress);
  const referral = new ethers.Contract(
    ALL_REFERRALS[chainId],
    referralAbi,
    signer
  );

  try {
    res = await referral.createReferralCode(userAddress, code);
    await showPendingAlert(res.hash, "Create Referral Code Succeed", provider);
  } catch (error: any) {
    if (error.message.includes("User denied transaction signature")) {
      showErrorAlert("You denied the transaction.");
    } else if (
      error.message.includes(
        "This referral code has already been assigned to an address."
      )
    ) {
      showErrorAlert(
        "This referral code has already been assigned to an address."
      );
    } else if (
      error.message.includes(
        "This address already has a referral code assigned."
      )
    ) {
      showErrorAlert("You have already created a referral code.");
    } else {
      showErrorAlert("Create Referral Code Failed");
    }
  }

  return res;
};

export const setReferralCode = async (
  userAddress: string,
  chainId: number,
  provider: any,
  code: string
) => {
  let res;

  const signer = provider.getSigner(userAddress);
  const referral = new ethers.Contract(
    ALL_REFERRALS[chainId],
    referralAbi,
    signer
  );

  try {
    res = await referral.setReferralCode(code);
    await showPendingAlert(res.hash, "Set Referral Code Succeed", provider);
  } catch (error: any) {
    if (error.message.includes("User denied transaction signature")) {
      showErrorAlert("You denied the transaction.");
    } else if (
      error.message.includes(
        "You cannot be a referee of a referral code you own"
      )
    ) {
      showErrorAlert("You cannot use your own referral code.");
    } else if (error.message.includes("referral code has already been set")) {
      showErrorAlert("You have already set the referral code.");
    } else if (error.message.includes("Referral code does not exist")) {
      showErrorAlert("The referral code you entered does not exist");
    } else {
      showErrorAlert("Set Referral Code Failed");
    }
  }

  return res;
};

export const claimReferralRewards = async (
  userAddress: string,
  chainId: number,
  provider: any,
  claimWeeks: (number | string[] | BigNumber)[][]
) => {
  let res;

  const signer = provider.getSigner(userAddress);
  const rewardVesting = new ethers.Contract(
    ALL_REWARD_VESTING[chainId],
    rewardVestingAbi,
    signer
  );

  try {
    res = await rewardVesting.claimWeeks(userAddress, claimWeeks);
    await showPendingAlert(res.hash, "Claim Rewards Succeed", provider);
  } catch (error: any) {
    if (error.message.includes("User denied transaction signature")) {
      showErrorAlert("You denied the transaction.");
    } else {
      console.log(error);
    }
  }

  return res;
};

export const getRewardClaimStatus = async (
  userAddress: string,
  chainId: number,
  provider: any,
  weekNum: number
) => {
  let res;

  const signer = provider.getSigner(userAddress);
  const rewardVesting = new ethers.Contract(
    ALL_REWARD_VESTING[chainId],
    rewardVestingAbi,
    signer
  );

  try {
    res = await rewardVesting.claimed(weekNum, userAddress);
  } catch (error: any) {
    console.log(error);
  }

  return res;
};
